import { FC, useEffect } from 'react'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { useStores } from '../../../utils'
import { TextAreaGroup } from '../TextAreaGroup'
import { SettingButton } from '../../atoms/SettingButton'
import { IAnswerBase, MessageType } from '../../../types'

type Props = {
  answer: IAnswerBase
  answers: IAnswerBase[]
  setAnswers: (answers: IAnswerBase[]) => void
  clickCancel: () => void
  setEdit: (isEdit: boolean) => void
}

type Value = {
  body: string
}

export const UpdateAnswerForm: FC<Props> = observer(({ answer, answers, setAnswers, clickCancel, setEdit }) => {
  const { t } = useTranslation(['p', 'validation'])
  const { messages, viewer } = useStores()
  const initialValue: Value = {
    body: answer.body,
  }

  const validationSchema = Yup.object().shape({
    body: Yup.string().required(t('validation:必須項目です')),
  })

  return (
    <div className={styles.container}>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={async (values: Value, actions) => {
          const output = await viewer.viewer?.updateMyAnswer(answer.id, values.body)
          actions.setSubmitting(false)
          if (output.isSuccessful) {
            const newAnswers = answers.map((a) => {
              if (a.id === output.data.answer.id) {
                return output.data.answer
              }
              return a
            })
            setAnswers(newAnswers)
            messages.add({
              type: MessageType.Info,
              body: 'Your reply changed.',
              isTranslated: true,
              ttl: 5000,
            })
            actions.resetForm()
            setEdit(false)
          }
        }}
      >
        {({ isSubmitting, setFieldValue }) => {
          useEffect(() => {
            if (!answer) {
              return
            }

            setFieldValue('body', answer?.body)
          }, [answer])
          return (
            <Form>
              <div className={styles.textarea}>
                <Field
                  name='body'
                  placeholder='Leave your reply'
                  fieldType='setting'
                  isSmall
                  component={TextAreaGroup}
                />
              </div>
              <div className={styles.buttonContainer}>
                <SettingButton
                  color='white'
                  buttonType='reset'
                  buttonSize='medium'
                  disabled={isSubmitting}
                  onClick={clickCancel}
                >
                  Cancel
                </SettingButton>
                <SettingButton
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                  color='aqa'
                  buttonType='submit'
                  buttonSize='medium'
                >
                  Save
                </SettingButton>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
})
